import { flattenReduxFormProps } from 'decorators';
import { Checkbox } from 'components/core/Checkbox';

export default flattenReduxFormProps(Checkbox);
